import { useParams } from 'react-router-dom';
import { useClient } from 'jsonapi-react';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import moreMedal from '@/assets/images/more-medal.svg';
import trophy from './img/trophy.svg';
import * as Fi from 'react-icons/fi';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import Medal from '../../../../app/components/Medal';
import courseMedal from '@/assets/images/course-medal.svg';
import { Loader } from '@/components/custom/loader';
import {
  ModalSuccess,
  ModalSuccessBody,
  ModalSuccessContainer,
  ModalSuccessContent,
  ModalSuccessHeader,
  ModalSuccessImg,
  ModalSuccessKpi,
  ModalSuccessKpiIcon,
  ModalSuccessKpiInner,
  ModalSuccessKpiLabel,
  ModalSuccessKpiValue,
  ModalSuccessKpiWrapper,
  ModalSuccessName,
  ModalSuccessTag,
  ModalSuccessText,
  ModalSuccessTitle
} from '@/components/custom/modal';
import { Button } from '@/components/ui/button';

export function CourseClassroomModalSuccess(props) {
  const { t } = useTranslation();
  const { show, onClose, header, title, learningSystemUser, learningSystem } = props;
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const client = useClient();
  const { id } = useParams();

  function closeOnEscapeKeyDown(event) {
    if (event.key === 'Escape') onClose();
  }

  const now = new Date();

  const downloadCertificate = () => {
    window.open(`${process.env.REACT_APP_DEV_URL}//user_certificates/download/${learningSystemUser?.course?.status === 'completed' ? learningSystemUser?.course?.hash_id : certificates?.[0]?.['hash-id']}.pdf`, '_blank');
  };

  useEffect(() => {
    document.body.addEventListener('keydown', closeOnEscapeKeyDown);

    return () => {
      document.body.removeEventListener('keydown', closeOnEscapeKeyDown);
      document.body.style.overflow = 'visible';
    };
  }, []);

  useEffect(() => {
    if (show) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'visible';
  }, [show]);

  const nodeRef = React.useRef(null); //Fix react-transition-group

  const getCertificates = async () => {
    setLoading(true);
    const { data, error } = await client.fetch(`user_certificates?filter[learning_systems.id]=${id}`);
    if (error) {
      toast.error(t('toast.errorGetCertifications'));
    } else {
      setCertificates(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (id && show) {
      getCertificates();
    }
  }, [id, show]);

  function getIcon(icon) {
    switch (icon) {
      case 'FiVideo':
        return (
          <ModalSuccessKpiIcon>
            <Fi.FiVideo />
          </ModalSuccessKpiIcon>
        );
      case 'FiMousePointer':
        return (
          <ModalSuccessKpiIcon>
            <Fi.FiMousePointer />
          </ModalSuccessKpiIcon>
        );
      case 'FiEdit3':
        return (
          <ModalSuccessKpiIcon>
            <Fi.FiEdit3 />
          </ModalSuccessKpiIcon>
        );
      case 'FiCheckCircle':
        return (
          <ModalSuccessKpiIcon>
            <Fi.FiCheckCircle />
          </ModalSuccessKpiIcon>
        );
      case 'FiMessageCircle':
        return (
          <ModalSuccessKpiIcon>
            <Fi.FiMessageCircle />
          </ModalSuccessKpiIcon>
        );
      case 'FiFolder':
        return (
          <ModalSuccessKpiIcon>
            <Fi.FiFolder />
          </ModalSuccessKpiIcon>
        );
    }
  }

  return ReactDOM.createPortal(
    <CSSTransition
      in={show}
      unmountOnExit
      nodeRef={nodeRef}
      timeout={{ enter: 0, exit: 300 }}
    >
      <ModalSuccess
        isActive={show}
        onClick={onClose}
        ref={nodeRef}
      >
        {loading ? (
          <Loader />
        ) : (
          <ModalSuccessContent onClick={event => event.stopPropagation()}>
            <ModalSuccessTag>{t('textsCommon.tagConcluded')}</ModalSuccessTag>

            <ModalSuccessImg
              src={trophy}
              alt=""
            />

            <ModalSuccessContainer>
              <ModalSuccessHeader>
                <ModalSuccessTitle>
                  {header}{' '}
                  <div className="medal">
                    <img
                      src={learningSystemUser?.course?.status !== 'completed' ? moreMedal : courseMedal}
                      alt="nova medalha"
                      className="medal__img"
                    />
                    <span className="medal__value">+1</span>
                  </div>
                </ModalSuccessTitle>
              </ModalSuccessHeader>

              <ModalSuccessBody>
                <ModalSuccessText>{title}</ModalSuccessText>
                <ModalSuccessName>{certificates?.[0]?.['learning-system']?.title}</ModalSuccessName>
                {learningSystem?.link && (
                  <>
                    <ModalSuccessText>Sua opinião importa! Responda nossa pesquisa e nos ajude a melhorar cada vez mais.</ModalSuccessText>
                    <Button
                      wide
                      asChild
                    >
                      <a
                        href={learningSystem?.link}
                        target="_blank"
                        style={{ backgroundColor: '#FF4C6F', color: 'white', fontWeight: 600, marginBottom: '20px' }}
                      >
                        Pesquisa de satisfação
                      </a>
                    </Button>
                  </>
                )}

                {/*{certificates.length > 0 && now >= new Date(learningSystem?.['finished-at']) ? (*/}
                {/*  <div>*/}
                {/*    <ModalSuccessText>{t('lms.moduleCompletedCertificateReady')}</ModalSuccessText>*/}
                {/*    <Button*/}
                {/*      variant="outline"*/}
                {/*      wide*/}
                {/*      onClick={downloadCertificate}*/}
                {/*    >*/}
                {/*      {t('lms.buttonGetCertificate')}*/}
                {/*    </Button>*/}
                {/*  </div>*/}
                {/*) : (*/}
                {/*  <ModalSuccessText>Seu certificado estará disponível em {new Date(learningSystem?.['finished-at'])?.toLocaleDateString('pt-br')}</ModalSuccessText>*/}
                {/*)}*/}
              </ModalSuccessBody>

              <ModalSuccessKpiWrapper>
                {learningSystemUser?.course?.status !== 'completed' &&
                  certificates?.[0]?.info?.map((item, index) => {
                    if (item.count > 0) {
                      return (
                        <ModalSuccessKpi>
                          {getIcon(item.icon)}
                          <ModalSuccessKpiInner>
                            {index === 1 && <Medal value={1} />}
                            <ModalSuccessKpiValue>{item.count}</ModalSuccessKpiValue>
                            <ModalSuccessKpiLabel>{item.label}</ModalSuccessKpiLabel>
                          </ModalSuccessKpiInner>
                        </ModalSuccessKpi>
                      );
                    }
                  })}
              </ModalSuccessKpiWrapper>
            </ModalSuccessContainer>
          </ModalSuccessContent>
        )}
      </ModalSuccess>
    </CSSTransition>,
    document.getElementById('modal_root')
  );
}
